import React from 'react';
import styles from '../Operations.module.css';

interface SO02Component extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

/**
 * SOCIMONTHLY - SOCI - Total Monthly Social Posts
 * KPI information component
 */
const SO02: SO02Component = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>

      <div className={styles.sectionContent}>
        Paid posts use advertising in Facebook called Boost or Facebook Ads.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>

      <div className={styles.sectionContent}>
        Facebook Ads are called &quot;dark posts&quot;. This means that the ad will not appear on your page.
        It will appear to the customers around your store. Facebook Ads have multiple options for consumer targeting.<br/><br/>
        Boosting is a form of Facebook advertising, and is recommended for clicks, engagements and/or short-term promotions. Facebook Boost has less targeting capabilities than &quot;Ads&quot;.
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>

      <div className={styles.sectionContent}>
        <ol>
          <li>Organic posts – post 2-3x per week.</li>
          <li>Paid posts – run 2 posts per month for 2-weeks at a time.</li>
        </ol>
      </div>

      <div className={styles.sectionTitle}>
       Learn More
      </div>

      <div className={styles.sectionContent}>
        For training, please visit Ace Learning Place and search SOCi for various platform topics.<br/>
        Sign-up and Questions:
        <ol>
          <li>Sign-up at no charge for the platform, visit <a href="https://www.soci.ai/acehardware/" target="_blank" rel="noopener noreferrer" className={styles.link}>www.soci.ai/acehardware/</a></li>
          <li>For questions, email, support@meetsoci.com</li>
        </ol>
      </div>
    </div>
  );
};


SO02.title = 'SOCi - Total Monthly Social Posts';
SO02.actionTitle = 'SOCi dashboard';
SO02.actionHyperlink = 'https://www.soci.ai/acehardware/';
export default SO02;

